import moment from "moment-timezone";

export const getMinTime = (
  minDate = new Date(),
  timeZone = moment.tz.guess(),
) => {
  const currentTime = moment(minDate);
  currentTime.set({ hour: moment.tz(timeZone).hour(), minute: "00" });
  const nextHour = currentTime.clone().add(1, "hour").startOf("hour");

  let minTime = null;
  if (!moment(minDate).isSame(moment(), "day")) {
    // If dateVal is tomorrow, minTime should be null
    minTime = null;
  } else {
    // If dateVal is today
    minTime = nextHour;
  }
  return minTime;
};

export const getCurrentTime = (
  minDate = new Date(),
  timeZone = moment.tz.guess(),
) => {
  const momentDate = moment(minDate);
  const timezoneDate = momentDate.tz(timeZone);
  timezoneDate.set({ hour: moment.tz(timeZone).hour(), minute: "00" });
  return timezoneDate;
};
